import { IMatch, IOffer } from '@/services/store/interfaces/offers.interfaces';
import { Order } from '@/templates/NewStore/types/order';
import { converterSlugParaTitulo } from './slugs';

const getInitials = (name: string) => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const parseDistanceKm = (raw?: string) => {
  if (!raw) return 0;
  // exemplos: "A 2 km", "2 km", "2,5 km"
  const m = raw.replace(',', '.').match(/(\d+(\.\d+)?)/);
  if (!m) return 0;
  return Number(m[1]);
};

export function offerToOrder(offer: IOffer): Order {
  const isViewed = offer.state !== 'unread';

  return {
    id: offer.offer_id,
    customerName: offer.customer,
    customerInitials: getInitials(offer.customer),

    category: offer.title,
    serviceType: offer.is_remote ? 'Remoto' : 'Presencial',

    isRemote: offer.is_remote,

    description: offer.subtitle ?? '',

    createdAt: new Date(), // PRECISA ADD

    distance: parseDistanceKm(String(offer.distance)),
    neighbourhood: offer.neighborhood ?? '',

    unlockedCount: offer.competition?.leads_count ?? 0,
    maxUnlocks: offer.competition?.leads_limit ?? 0,

    isUrgent: offer.urgency === 0,

    isHighlighted: Boolean(offer.customer_paid),

    isRecommended: false, // PRECISA ADD

    isViewed,

    coinCost: 0, // PRECISA ADD

    attachedImages: 0, // PRECISA ADD
    photos: [], // PRECISA ADD

    suggestedPrice: undefined, // PRECISA ADD
    estimatedDuration: undefined, // PRECISA ADD

    location: {
      city: '',
      state: '',
      zipCode: '',
    }, // PRECISA ADD

    questionsAndAnswers: [], // PRECISA ADD

    clientInfo: {
      memberSince: '',
      completedRequests: 0,
      hasWhatsApp: false,
    }, // PRECISA ADD
  };
}

export function matchOfferToOrder(offer: IOffer): Order {
  const isViewed = offer.state !== 'unread';

  return {
    id: offer.offer_id,
    customerName: offer.customer,
    customerInitials: getInitials(offer.customer),

    category: offer.title,
    serviceType: offer.is_remote ? 'Remoto' : 'Presencial',

    isRemote: offer.is_remote,

    description: offer.subtitle ?? '',

    createdAt: new Date(), // PRECISA ADD

    distance: parseDistanceKm(String(offer.distance)),
    neighbourhood: offer.neighborhood ?? '',

    unlockedCount: offer.competition?.leads_count ?? 0,
    maxUnlocks: offer.competition?.leads_limit ?? 0,

    isUrgent: offer.urgency === 0,

    isHighlighted: Boolean(offer.customer_paid),

    isRecommended: true, // PRECISA ADD

    isViewed,

    coinCost: 0, // PRECISA ADD

    attachedImages: 0, // PRECISA ADD
    photos: [], // PRECISA ADD

    suggestedPrice: undefined, // PRECISA ADD
    estimatedDuration: undefined, // PRECISA ADD

    location: {
      city: '',
      state: '',
      zipCode: '',
    }, // PRECISA ADD

    questionsAndAnswers: [], // PRECISA ADD

    clientInfo: {
      memberSince: '',
      completedRequests: 0,
      hasWhatsApp: false,
    }, // PRECISA ADD
  };
}

export function matchListToOrders(matchList: IOffer[]): Order[] {
  return matchList.map(matchOfferToOrder);
}

export function offersListToOrders(offersList: IOffer[]): Order[] {
  return offersList.map(offerToOrder);
}
